import React from "react";
import AnalyticsChart from "./AnalyticsChart";

function AnalyticsDataTable({
  title,
  description,
  loading,
  rows,
  columns,
  noDataLabel,
  emptyIcon = "zmdi-view-list",
  loadingHeight = 260,
  rowKey = "id",
  tableClassName = "",
  cardClassName = "",
  toolbar,
  footer,
}) {
  const resolvedRows = rows || [];
  const tableClasses = ["table", "table-sm", "table-hover", "mb-0", "analytics-data-table__table", tableClassName].filter(Boolean).join(" ");

  const resolveRowKey = (row, index) => {
    if (typeof rowKey === "function") return rowKey(row, index);
    return row?.[rowKey] || index;
  };

  return (
    <AnalyticsChart
      title={title}
      description={description}
      loading={loading}
      isEmpty={!resolvedRows.length}
      noDataLabel={noDataLabel}
      emptyIcon={emptyIcon}
      loadingHeight={loadingHeight}
      cardClassName={cardClassName}
      toolbar={toolbar}
      footer={footer}
    >
      <div className="table-responsive analytics-data-table">
        <table className={tableClasses}>
          <thead>
            <tr>
              {columns.map((column) => (
                <th key={column.key || column.label} className={column.thClassName}>
                  {column.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {resolvedRows.map((row, rowIndex) => (
              <tr key={resolveRowKey(row, rowIndex)}>
                {columns.map((column) => (
                  <td key={column.key || column.label} className={column.tdClassName}>
                    {column.render ? column.render(row, rowIndex) : row[column.key]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </AnalyticsChart>
  );
}

export default AnalyticsDataTable;
